import xhr from "../Helper/axiosInterceptor";
import { URL_LOGOUT } from "../Config/Api";

export function hideSubsEmailAddr(email) {
  if (!email) return "";
  const [username, domain] = email.split("@");

  const hideLength = Math.max(Math.floor(username.length / 2), 1);

  const hiddenPart = "*".repeat(hideLength);

  return `${username.slice(0, -hideLength)}${hiddenPart}@${domain}`;
}

export async function destroySession({ dataUser }) {
  try {
    await xhr(URL_LOGOUT, "POST", {
      id: dataUser.user_id,
    });
  } catch (error) {
    throw error;
  }
}

export function splitFullName(fullname) {
  const parts = fullname.trim().split(" ");
  const first_name = parts[0] || "";
  const last_name = parts.slice(1).join(" ") || "";

  return { first_name, last_name };
}
export function desanitizeInput(sanitizedString) {
  if (sanitizedString === null || sanitizedString === undefined) {
    return "";
  }

  return String(sanitizedString)
    .replace(/&amp;/g, "&")
    .replace(/&lt;/g, "<")
    .replace(/&gt;/g, ">")
    .replace(/&quot;/g, '"')
    .replace(/&#x27;/g, "'")
    .replace(/&#x2F;/g, "/");
}
